module.exports = __webpack_public_path__ + "static/media/tyler-matthews.3338a042.png";